<p-dialog
  header="Select scene..."
  styleClass="[&>.p-dialog-content]:!rounded-b-xl [&>.p-dialog-header]:!rounded-t-xl [&>.p-dialog-content]:!bg-bo-white/50 [&>.p-dialog-content]:!backdrop-blur-md [&>.p-dialog-header]:!bg-bo-white/30 [&>.p-dialog-header]:!backdrop-blur-md"
  [visible]="showSceneLauncher()"
  (visibleChange)="toggleSceneLauncher()"
  [style]="{ width: '50vw' }"
  [modal]="true"
  [dismissableMask]="true"
  [resizable]="false"
  data-e2e="scene-launcher"
>
  <ng-template pTemplate="header">
    <div class="bo-subheader select-none !text-bo-black">Select scene...</div>
  </ng-template>
  <div class="mt-4 flex select-none flex-col gap-3 px-6">
    <div class="flex">
      <button
        class="bo-button w-full"
        (click)="selectScene('precisionCutting')"
      >
        Precision Cutting
      </button>
      <button
        class="bo-button-secondary ml-2"
        (click)="selectDemo('precisionCutting')"
        data-e2e="button-precisionCutting"
      >
        Demo
      </button>
      <div class="ml-2 h-10 w-2 p-1">
        @if (showLoader() && selectedScene === 'precisionCutting') {
          <ng-lottie [options]="{ path: '/animations/loading.json' }" />
        }
      </div>
    </div>
    <div class="flex">
      <button class="bo-button w-full" (click)="selectScene('ligatingLoop')">
        Ligating loop
      </button>
      <button
        class="bo-button-secondary ml-2"
        (click)="selectDemo('ligatingLoop')"
        data-e2e="button-ligatingLoop"
      >
        Demo
      </button>
      <div class="ml-2 h-10 w-2 p-1">
        @if (showLoader() && selectedScene === 'ligatingLoop') {
          <ng-lottie [options]="{ path: '/animations/loading.json' }" />
        }
      </div>
    </div>
    <div class="flex">
      <button
        class="bo-button w-full"
        (click)="selectScene('intracorporealKnot')"
      >
        Intracorporeal knot
      </button>
      <button
        class="bo-button-secondary ml-2"
        (click)="selectDemo('intracorporealKnot')"
        data-e2e="button-intracorporealKnot"
      >
        Demo
      </button>
      <div class="ml-2 h-10 w-2 p-1">
        @if (showLoader() && selectedScene === 'intracorporealKnot') {
          <ng-lottie [options]="{ path: '/animations/loading.json' }" />
        }
      </div>
    </div>
    <div class="flex">
      <button
        class="bo-button w-full"
        (click)="selectScene('extracorporealKnot')"
      >
        Extracorporeal knot
      </button>
      <button
        class="bo-button-secondary ml-2"
        (click)="selectDemo('extracorporealKnot')"
        data-e2e="button-extracorporealKnot"
      >
        Demo
      </button>
      <div class="ml-2 h-10 w-2 p-1">
        @if (showLoader() && selectedScene === 'extracorporealKnot') {
          <ng-lottie [options]="{ path: '/animations/loading.json' }" />
        }
      </div>
    </div>
    <div class="flex">
      <button class="bo-button w-full" (click)="selectScene('pegTransfer')">
        Peg transfer
      </button>
      <button
        class="bo-button-secondary ml-2"
        (click)="selectDemo('pegTransfer')"
        data-e2e="button-pegTransfer"
      >
        Demo
      </button>
      <div class="ml-2 h-10 w-2 p-1">
        @if (showLoader() && selectedScene === 'pegTransfer') {
          <ng-lottie [options]="{ path: '/animations/loading.json' }" />
        }
      </div>
    </div>
    <div class="flex">
      <button class="bo-button w-full" (click)="selectScene('stratafix')">
        Stratafix
      </button>
      <button
        class="bo-button-secondary ml-2"
        (click)="selectDemo('stratafix')"
        data-e2e="button-stratafix"
      >
        Demo
      </button>
      <div class="ml-2 h-10 w-2 p-1">
        @if (showLoader() && selectedScene === 'stratafix') {
          <ng-lottie [options]="{ path: '/animations/loading.json' }" />
        }
      </div>
    </div>
  </div>
</p-dialog>
